import React from 'react'
import { MagicSpinner } from 'react-spinners-kit'
import { useStyles } from './Styles'

export const FormLoader = ({ loading, size }) => {
  let classes = useStyles()
  return (
    <div className={classes.formLoaderWrapper}>
      <MagicSpinner
        size={size || 100}
        color="#438fce"
        loading={loading}
      />
    </div>
  )
}
